'use client';

import dynamic from 'next/dynamic';

const DashboardChartsClient = dynamic(
  () => import('./DashboardChartsClient'),
  { ssr: false, loading: () => (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
      <div className="bg-card border border-border rounded-xl p-5 h-72 animate-pulse" />
      <div className="bg-card border border-border rounded-xl p-5 h-72 animate-pulse" />
    </div>
  )}
);

export default function DashboardCharts() {
  return <DashboardChartsClient />;
}